import { createAction, props } from '@ngrx/store';
import {
  ContentSettingsModel,
  DomainSettingsModel,
  FilterTargetModel,
  GMOoYRModel,
  GroupReportsConfigTemplateModel,
  GroupReportsTemplateModel,
  LikertScaleSettingsModel,
  PerformanceSettingsModel,
  ScoreBarSettingsModel,
} from './groupTemplate.model';

export const GroupTemplateActions = {
  loadTemplate: createAction('[Group Reports Template Builder] Load', props<{ templateOid: number }>()),
  loadTemplateSuccess: createAction(
    '[Group Reports Template Builder] Load Success',
    props<{ template: GroupReportsTemplateModel | null }>(),
  ),
  loadTemplateFailure: createAction('[Group Reports Template Builder] Load Failure', props<{ error: string }>()),
  initNewTemplate: createAction('[Group Reports Template Builder] Init New Template'),
  updateTemplateInformation: createAction(
    '[Group Reports Template Builder] Update Template Information',
    props<{ templateName: string; templateDescription: string }>(),
  ),
  updateSelectedSurvey: createAction(
    '[Group Reports Template Builder] Update Selected Survey',
    props<{ surveyVersionOid: number }>(),
  ),
  updateTemplateConfig: createAction(
    '[Group Reports Template Builder] Update Template Config',
    props<{ templateConfig: Partial<GroupReportsConfigTemplateModel> }>(),
  ),
  updateTemplateGMOoYR: createAction(
    '[Group Reports Template Builder] Update Template GMOoYR',
    props<{ templateGMOoYR: Partial<GMOoYRModel> }>(),
  ),
  updateContentSettings: createAction(
    '[Group Reports Template Builder] Update Content Settings',
    props<{ contentSettings: Partial<ContentSettingsModel> }>(),
  ),
  updateLikertScaleSettings: createAction(
    '[Group Reports Template Builder] Update Likert Scale Settings',
    props<{ likertScaleSettings: Partial<LikertScaleSettingsModel> }>(),
  ),
  updateScoreBarSettings: createAction(
    '[Group Reports Template Builder] Update Score Bar Settings',
    props<{ scoreBarSettings: Partial<ScoreBarSettingsModel> }>(),
  ),
  updatePerformanceSettings: createAction(
    '[Group Reports Template Builder] Update Performance Settings',
    props<{ performanceSettings: Partial<PerformanceSettingsModel> }>(),
  ),
  updateDomainSettings: createAction(
    '[Group Reports Template Builder] Update Domain Settings',
    props<{ domainsSettings: DomainSettingsModel[] }>(),
  ),
  updateFilterTarget: createAction(
    '[Group Reports Template Builder] Update Filter Target',
    props<{ filterTarget: Partial<FilterTargetModel> }>(),
  ),
  updateFilterBenchmark: createAction(
    '[Group Reports Template Builder] Update Filter Benchmark',
    props<{ filterBenchmark: Partial<FilterTargetModel> }>(),
  ),
  saveTemplateBuilder: createAction(
    '[Group Reports Template Builder] Save Template Builder',
    props<{ templateOid: number; template: GroupReportsTemplateModel; isNew: boolean; redirectToList?: boolean }>(),
  ),
  saveTemplateBuilderSuccess: createAction(
    '[Group Reports Template Builder] Save Template Builder Success',
    props<{ templateOid: number; redirectToList?: boolean }>(),
  ),
  saveTemplateBuilderFailure: createAction(
    '[Group Reports Template Builder] Save Template Builder Failure',
    props<{ error: string }>(),
  ),
  setTemplateValidation: createAction(
    '[Group Reports Template Builder] Set Template Validation',
    props<{ surveyInvalid: boolean; templateNameInvalid: boolean }>(),
  ),
  resetStore: createAction('[Group Reports Template Builder] Reset Store'),
};
